/**
 * Sticky Header
 * Adds a class to header on scroll
 */
import magnificPopup from '../vendors/jquery-magnificpopup';
import organicTabs from '../vendors/organic-tab';
import slick from '../vendors/slick.min';
import carousel from '../vendors/owl.carousel.min';





jQuery( document ).on( 'scroll', function() {
	var scrollTop = jQuery( document ).scrollTop();

	// Desktop compact header slides in from top (no side slide); mobile keeps early shrink
	var shrinkPoint = window.matchMedia( '(min-width: 1151px)' ).matches ? 80 : 0;

	if ( scrollTop > shrinkPoint ) {
		jQuery( 'header, body' ).addClass( 'shrink' );
	} else {
		jQuery( 'header, body' ).removeClass( 'shrink' );
	}

	// Sticky "Call Us" button: hide at top, slide up from bottom on scroll
	if ( scrollTop > 150 ) {
		jQuery( '.sticky-btn' ).addClass( 'is-visible' );
	} else {
		jQuery( '.sticky-btn' ).removeClass( 'is-visible' );
	}
} );

jQuery( function($) {
	/**
	 * Header Wrapper Height Calculation for Navigation Overlay
	 */

	if ( jQuery( '.header-wrapper' ).length > 0 ) {
		function updateHeaderHeight() {
			jQuery( '.header-wrapper' ).each( function() {
				jQuery( this ).css( '--rfs_header-wrapper-default', jQuery( this ).outerHeight() + 'px' );
			} );
		}
		updateHeaderHeight();
		jQuery( window ).resize( updateHeaderHeight );
	}

	/**
	 * Toggle menu for mobile
	 */
	const navOverlay = jQuery( '.nav-overlay' );
	const htmlBody = jQuery( 'html, body' );

	jQuery( '.menu-btn' ).on( 'click', function() {
		jQuery( this ).toggleClass( 'active' );
		navOverlay.toggleClass( 'open' );
		htmlBody.toggleClass( 'no-overflow' );
		jQuery( '.header-nav ul li.active' ).removeClass( 'active' );
		jQuery( '.header-nav ul.sub-menu' ).slideUp();
	} );

	/**
	 * Add span tag to multi-level accordion menu for mobile menus
	 * (skip if icon already exists — avoids duplicates when scripts re-run)
	 */
	jQuery( '.menu-item-has-children > a:first-child' ).each( function() {
		if ( ! jQuery( this ).siblings( '.submenu-icon' ).length ) {
			jQuery( this ).after( '<span class="submenu-icon"></span>' );
		}
	} );

	/**
	 * Slide Up/Down internal sub-menu when mobile menu arrow clicked
	 * Bind once on .header-navigation — WP nests two .header-nav wrappers,
	 * which previously fired this toggle twice (open then immediate close).
	 */
	jQuery( '.header-navigation' )
		.off( 'click.submenuToggle', '.submenu-icon' )
		.on( 'click.submenuToggle', '.submenu-icon', function( e ) {
			e.preventDefault();
			e.stopPropagation();

			const parentLi = jQuery( this ).closest( 'li.menu-item-has-children' );

			parentLi.siblings( '.active' )
				.removeClass( 'active' )
				.children( 'ul' ).slideUp();

			parentLi.toggleClass( 'active' );
			parentLi.children( 'ul' ).stop( true, true ).slideToggle();
			parentLi.parents( 'ul' ).toggleClass( 'disabled-menu', parentLi.hasClass( 'active' ) );
		} );

	/**
	 *  Accessibility for Simple menu & Mega menu
	 */
	jQuery( '.menu-item-has-children > a' ).on( 'focus blur', function( event ) {
		jQuery( this ).siblings( '.sub-menu, .mega-menu' ).toggleClass( 'focused', event.type === 'focus' );
	} );

	jQuery( '.sub-menu a, .mega-menu a' ).on( 'focus blur', function( event ) {
		jQuery( this ).closest( '.sub-menu, .mega-menu' ).toggleClass( 'focused', event.type === 'focus' );
	} );

	/**
	 * Script for Accessibility of html Tags
	 */
	jQuery( 'h1, h2, h3, h4, h5, h6,p,li,blockquote,cite,strong,dt,dd,th,td,b,i,u,s,em,small,sup,del,ins,abbr,mark,details,pre,kbd,samp,var,address,code,q,figure,figcaption,caption,.top-bar-text,.top-bar-cross,.copy-right,.post-author-img,.post-author-name,.post-meta-date,.post-date' ).each( function() {
		jQuery( this ).attr( {
			tabindex: 0,
		} );
	} );
	jQuery( '.header-nav li, .blog-nav li, .footer-nav li, .legal-nav li' ).each( function() {
		const link = jQuery( this ).find( 'a' );
		if ( link.length > 0 ) {
			jQuery( this ).removeAttr( 'tabindex' );
		} else {
			jQuery( this ).attr( 'tabindex', '0' );
		}
	} );
	jQuery( 'form p' ).each( function() {
		jQuery( this ).removeAttr( 'tabindex' );
	} );

	jQuery( 'a,button:not([href])' ).each( function() {
		jQuery( this ).attr( {
			tabindex: 0,
		} );
	} );

	setTimeout( () => {
		jQuery( '#daextlwcnf-cookie-notice-button-1' ).attr( 'role', 'button' );
		jQuery( '#daextlwcnf-cookie-notice-button-2' ).attr( 'role', 'button' );
		jQuery( '#daextlwcnf-cookie-settings-button-1' ).attr( 'role', 'button' );
		jQuery( '#daextlwcnf-cookie-settings-button-2' ).attr( 'role', 'button' );
	}, 500 );

	autosize();
	function autosize() {
		const text = jQuery( 'textarea' );

		text.each( function() {
			jQuery( this ).attr( 'rows', 5 );
			resize( jQuery( this ) );
		} );

		text.on( 'input', function() {
			resize( jQuery( this ) );
		} );

		function resize( $text ) {
			$text.css( 'min-height', 'auto' );
			$text.css( 'min-height', $text[ 0 ].scrollHeight + 'px' );
		}
	}

    // ====================================================================
    // MODEL JS 
    // ====================================================================

    function openModal(modalId) {
        var $modal = $("#" + modalId);
        var $content = $modal.find(".modal-contents");

        $modal.css({
            display: "block",
            overflowY: "auto"
        });

        var viewportHeight = $(window).height();
        var viewportWidth = $(window).width();
        var contentHeight = $content.outerHeight();
        var contentWidth = $content.outerWidth();

        var topPosition = contentHeight < viewportHeight
            ? (viewportHeight - contentHeight) / 2
            : 20;

        var leftPosition = (viewportWidth - contentWidth) / 2;

        $content.css({
            position: "absolute",
            top: "0px",
            left: leftPosition + "px",
            opacity: 0,
            maxHeight: "90vh",
            overflowY: "auto"
        });

        setTimeout(function () {
            $content.css({
                transition: "top 0.5s, opacity 0.5s",
                top: topPosition + "px",
                opacity: 1,
            });
        }, 10);
    }


    function closeModal(modalId) {
        var $modal = $("#" + modalId);
        var $content = $modal.find(".modal-contents");

        $content.css({
            transition: "top 0.5s, opacity 0.5s",
            opacity: 0,
            top: "0px",
        });

        setTimeout(function () {
            $modal.css("display", "none");
        }, 500);
    }


        $("a[href^='#']").on("click", function (event) {
            event.preventDefault();
            var modalId = $(this).attr("href").substring(1);
            openModal(modalId);
        });

        $(window).on("click", function (event) {
            $(".styles-modal").each(function () {
                var $modal = $(this);
                if ($(event.target).is($modal)) {
                    closeModal($modal.attr("id"));
                }
            });
        });

        $(".close-btns").on("click", function () {
            var $modal = $(this).closest(".styles-modal");
            stopIframeVideo($modal);
        });

        $(window).on("click", function (event) {
            $(".styles-modal").each(function () {
                var $modal = $(this);
                if ($(event.target).is($modal)) {
                    stopIframeVideo($modal);
                }
            });
        });

        function stopIframeVideo($modal) {
            $modal.find("iframe").each(function () {
                var $iframe = $(this);
                var src = $iframe.attr("src");
                $iframe.attr("src", "");
                setTimeout(function () {
                    $iframe.attr("src", src);
                }, 500);
            });
        }

    // ====================================================================
    // CLOSE MODAL JS (SEPARATE)
    // ====================================================================


    $(".close-btns").on("click", function (e) {
        e.stopPropagation(); // window click conflict avoid

        var modalId = $(this).data("modal");
        closeModal(modalId);
    });

    // ====================================================================
    // Accordion JS
    // ====================================================================


    (function () {
        document.querySelectorAll(".accordion-container").forEach(container => {
            const accordions = container.querySelectorAll(".accordions");

            if (accordions[0]) {
                accordions[0].classList.add("active");
                accordions[0].parentElement.classList.add("active");
                accordions[0].nextElementSibling.style.maxHeight = 
                    accordions[0].nextElementSibling.scrollHeight + "px";
            }

            accordions.forEach(accordion => {
                accordion.addEventListener("click", () => {
                    const isActive = accordion.classList.contains("active");

                    accordions.forEach(acc => {
                        acc.classList.remove("active");
                        acc.parentElement.classList.remove("active");
                        acc.nextElementSibling.style.maxHeight = null;
                    });

                    if (!isActive) {
                        accordion.classList.add("active");
                        accordion.parentElement.classList.add("active");
                        accordion.nextElementSibling.style.maxHeight = 
                            accordion.nextElementSibling.scrollHeight + "px";
                    }
                });
            });
        });
    })();

    // FAQ Table of Contents: smooth scroll + scroll spy
    (function () {
      const tocRoot = document.querySelector('.row-faq .table-links');
      if (!tocRoot) return;

      const tocLinks = tocRoot.querySelectorAll('a[href^="#"]');
      const sections = Array.from(tocLinks)
        .map((link) => document.querySelector(link.getAttribute('href')))
        .filter(Boolean);

      if (!tocLinks.length || !sections.length) return;

      const setActiveLink = (id) => {
        tocRoot.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
        const activeLink = tocRoot.querySelector(`a[href="#${id}"]`);
        if (activeLink && activeLink.parentElement) {
          activeLink.parentElement.classList.add('active');
        }
      };

      tocLinks.forEach((anchor) => {
        anchor.addEventListener('click', function (e) {
          e.preventDefault();
          const targetId = this.getAttribute('href');
          const targetElement = document.querySelector(targetId);
          if (!targetElement) return;

          setActiveLink(targetId.slice(1));
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        });
      });

      const scrollOffset = 140;

      const updateActiveOnScroll = () => {
        let currentId = sections[0].id;

        sections.forEach((section) => {
          if (window.scrollY >= section.offsetTop - scrollOffset) {
            currentId = section.id;
          }
        });

        setActiveLink(currentId);
      };

      window.addEventListener('scroll', updateActiveOnScroll, { passive: true });
      updateActiveOnScroll();
    })();

    // Smooth scroll for other in-page hash links (skip FAQ TOC — handled above)
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      if (anchor.closest('.row-faq .table-links')) return;

      anchor.addEventListener('click', function (e) {
        const targetId = this.getAttribute('href');
        if (!targetId || targetId === '#') return;

        const targetElement = document.querySelector(targetId);
        if (!targetElement) return;

        e.preventDefault();
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      });
    });

    /**
	 *  ========================== Slick SLider ====================
	 */
	var sync1 = $("#sync1");
	var sync2 = $("#sync2");

	if (!sync1.length || !sync2.length) return; // safety

	sync1.owlCarousel({
		items: 1,
		nav: true,
		dots: false,
		loop: true,
		autoplay: false
	}).on('changed.owl.carousel', function (event) {
		var index = event.item.index - event.relatedTarget._clones.length / 2;
		var count = event.item.count;

		if (index < 0) index = count - 1;
		if (index >= count) index = 0;

		sync2.find(".owl-item").removeClass("current");
		sync2.find(".owl-item").eq(index).addClass("current");

		sync2.trigger('to.owl.carousel', [index, 300, true]);
	});

	sync2.owlCarousel({
		items: 4,
		margin: 10,
		dots: false,
		nav: false,
		smartSpeed: 200,
		slideBy: 1,
		responsive: {
			0: { items: 2 },
			600: { items: 3 },
			1000: { items: 4 }
		}
	});

	sync2.on("click", ".owl-item", function () {
		var index = $(this).index();
		sync1.trigger('to.owl.carousel', [index, 300, true]);
	});

} );

function initResponsiveOwlSlider(selector, options = {}) {
    const $slider = jQuery(selector);

    if (!$slider.length) {
        return;
    }

    let resizeTimer;

    const buildSlider = () => {
        if ($slider.hasClass('owl-loaded')) {
            $slider.trigger('destroy.owl.carousel');
        }

        $slider.owlCarousel({
            loop: true,
            autoplay: true,
            smartSpeed: 1000,
            autoplayTimeout: 3000,
            responsiveRefreshRate: 100,
            checkVisibility: true,
            ...options,
        });
    };

    buildSlider();

    jQuery(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(buildSlider, 150);
    });
}

jQuery(document).ready(function ($) {
    initResponsiveOwlSlider('.logo-slider', {
        margin: 24,
        nav: false,
        dots: false,
        autoplay: true,
        smartSpeed: 1000,
        autoplayTimeout: 3000,
        responsive: {
            0: {
                items: 1
            },
            590: {
                items: 3
            },
            900: {
                items: 4
            },
            1100: {
                items: 5
            }
        }
    });

    initResponsiveOwlSlider('.banner-sliders', {
        loop: true,
        margin: 0,
        nav: true,
        dots:true,
        autoplay: true,
        smartSpeed: 2000,
        autoplayTimeout: 6000,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 1
            },
            1000: {
                items: 1
            }
        }
    });
});


jQuery(document).ready(function ($) {
    $('.testimonial-sliders').owlCarousel({
        loop: true,
        margin: 20,
        nav: true,
        dots:true,
        autoplay: true,
        smartSpeed: 1000,
        autoplayTimeout: 3000,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 1
            },
            1000: {
                items: 1
            }
        }
    });
});

jQuery(document).ready(function ($) {
    $('.popup-slider').owlCarousel({
        loop: true,
        margin: 20,
        nav: true,
        dots:false,
        autoplay: true,
        smartSpeed: 1000,
        autoplayTimeout: 3000,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 1
            },
            1000: {
                items: 1
            }
        }
    });
});





jQuery(document).ready(function ($) {
    $('.related-slider').owlCarousel({
        loop: true,
        margin: 24,
        nav: true,
        dots:false,
        autoplay: true,
        smartSpeed: 1000,
        autoplayTimeout: 3000,
        responsive: {
            0: {
                items: 1
            },
			 700: {
                items: 2
            },
            900: {
                items: 3
            },
            1100: {
                items: 3
            }
        }
    });
});


jQuery(document).ready(function ($) {
    $('.project-slider').owlCarousel({
        loop: true,
        margin: 32,
        nav: false,
        dots:true,
        autoplay: false,
        smartSpeed: 1000,
		center: true,
        autoplayTimeout: 3000,
        responsive: {
            0: {
                items: 1
            },
            1000: {
                items: 1,
				stagePadding: 180,
            },
            1420: {
				stagePadding: 380,
                items: 1
            },
			 1680: {
				stagePadding: 180,
                items: 2
            }
        }
    });
});



document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();

    const targetId = this.getAttribute('href');
    const targetElement = document.querySelector(targetId);

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth', // smooth scroll
        block: 'start'      // top par le aata hai
      });
    }
  });
});


const navLinks = document.querySelectorAll("li a");

navLinks.forEach(link => {
  link.addEventListener("click", function () {

    // sab li se active remove karo
    document.querySelectorAll("li").forEach(li => {
      li.classList.remove("active");
    });

    // jis par click hua uske parent li par active lagao
    this.parentElement.classList.add("active");
  });
});




// ---------------- Scroll Steps Circles ----------------
window.addEventListener("scroll", function () {
    let steps = document.querySelectorAll(".step");

    steps.forEach((step, index) => {
        let circle = step.querySelector(".progress");
        let rect = step.getBoundingClientRect();

        // circumference (r=47 => ~298.45)
        let circumference = 298.45;

        if (rect.top < window.innerHeight / 1.3) {
            // sirf niche se enter karne par fill
            let progress = (index + 1) * (circumference / steps.length);
            circle.style.strokeDasharray = circumference;
            circle.style.strokeDashoffset = circumference - progress;
        } else {
            // upar scroll kar ke reset
            circle.style.strokeDasharray = circumference;
            circle.style.strokeDashoffset = circumference;
        }
    });
});






document.addEventListener('DOMContentLoaded', function () {
                            GLightbox({
                                selector: '.portfolio-lightbox'
                            });
});


